import React, { Component } from 'react'
import Settings from '../settings'
import ReactHtmlParser from 'react-html-parser'

// This component has:
// 1. Page title
// 2. Subtitle
// 3. Orb animations

// Import animation library
import { TimelineMax, Sine } from 'TweenMax'
import ScrollMagic from 'scrollmagic'
import 'animation.gsap'
import 'debug.addIndicators'
import 'ScrollToPlugin'

import IconSquare from './icons/IconSquare'

class Header extends Component {

   componentWillMount() {
    // Setup object id, and a place to store animations
    this.section = 'Header'
  }

   componentDidMount() {
      Settings.animation.on && Settings.animation.header_titles && this.animateTitle()
      // Settings.animation.on && Settings.animation.header_orb && this.animateOrb()

      // Setup animations once the component is actually in scope
       if (Settings.animation.on && Settings.animation.scroll) {

         // Add 'appear' animation to ScrollMagic
         const scene = new ScrollMagic
         .Scene({triggerElement: '.scroll-start', duration: 1000})
         .setTween( this.animateEnter() )
         .addTo(this.props.controller)

         // Add in-page markers for debugging - turn off before 'npm run build'
         Settings.animation.scroll_indicators && scene.addIndicators()
       }
   }

   scrollTo = (e, url) => {
      if (
         Settings.animation.scrollTo
         && url.includes('#')
         && !url.includes('/#')
         && document.querySelector(url)
      ) {
         e.preventDefault()
         new TimelineMax().to(window, Settings.animation.on ? 2 : 0, {scrollTo: url, ease: Sine.easeInOut })
         this.setState({toggle: 0})
      }
   }

   animateEnter = () => {
      const tl = new TimelineMax()

      // let elements = document.getElementsByClassName('.h1-top')
      tl.to('#header-orb', 1, {
         css: {
          y: '-600px'
         },
      })
      return tl
   }

   animateTitle = () => {
      new TimelineMax()
      .staggerFrom('.header-title-japanese, #header-orb, .header-title, .header-subtitle', 1, {
         css: {
           opacity: 0,
         },
         ease: Sine.easeInOut
      }, 0.4)
   }

   // Unused
   animateOrb = () => {
      new TimelineMax()
      .from('#header-orb', 5, {
         opacity: 0,
         scale: 0.8,
         ease: Sine.easeOut
      })
      .to('#header-orb', 4, {
         scale: 1.05,
         ease: Sine.easeInOut,
         repeat: -1, yoyo: true
      })
   }

   renderButton = (button, i) => {
      return (
         <div className="col s6">
         <a key={i} href={button.url} alt={button.alt}>
            <button className={button.type}>
               <span>{button.subtitle}</span>
               {button.title}
            </button>
         </a>
         </div>
      )
   }

   render() {
      const {
        title = 'That Day Now',
        title_japanese = 'あの日<div class="inline-block header-title-japanese-kern">、</div>今',
        subtitle = 'Keiko Ogura',
        subtitle_japanese = '小倉桂子'
      } = this.props.data

      return (
         <div className="Header">


            <div>

              <div className="scroll-start"></div>

               <div className="header-title-japanese use-gpu">
                  <a href="#main" className="header-title-a" onClick={(e) => this.scrollTo(e, '#main')}><h1 className="h1-top use-gpu">{ReactHtmlParser(title_japanese)}</h1></a>
               </div>

               <div>
                  {/* <a href="#main" className="header-orb-a" onClick={(e) => this.scrollTo(e, '#main')}> */}
                    <div id="header-orb" className="orb use-gpu"></div>
                  {/* </a> */}
               </div>

               <div id="main" className="header-title use-gpu">
                  <h1 className="h1-bottom orange header-title-english">{title}</h1>
               </div>

               <div className="header-subtitle use-gpu">
                  <h2><IconSquare size="30px" />&nbsp;&nbsp;&nbsp;{subtitle}&nbsp;&nbsp;&nbsp;{subtitle_japanese}&nbsp;&nbsp;&nbsp;<IconSquare size="30px" /></h2>
               </div>

            </div>

            <div className="scroll-end"></div>
         </div>
      )
   }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js